import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f9c60dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_input = _resolveComponent("app-input")!
  const _component_app_select = _resolveComponent("app-select")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h4", null, _toDisplayString(_ctx.$localize('profile.edit.contact.title')), 1),
    _createVNode(_component_Form, {
      as: "el-form",
      "validation-schema": _ctx.schema
    }, {
      default: _withCtx(() => [
        _createVNode(_component_app_input, {
          modelValue: _ctx.profileStore.bufferProfile.email,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.profileStore.bufferProfile.email) = $event)),
          name: "email",
          type: "email",
          inputmode: "email",
          label: _ctx.$localize('profile.edit.contact.email'),
          placeholder: _ctx.$localize('profile.edit.contact.add.email')
        }, null, 8, ["modelValue", "label", "placeholder"]),
        _createVNode(_component_app_input, {
          modelValue: _ctx.profileStore.bufferProfile.phone,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.profileStore.bufferProfile.phone) = $event)),
          name: "phone",
          type: "tel",
          inputmode: "tel",
          label: _ctx.$localize('profile.edit.contact.phone'),
          placeholder: _ctx.$localize('profile.edit.contact.add.phone')
        }, null, 8, ["modelValue", "label", "placeholder"]),
        _createVNode(_component_app_input, {
          modelValue: _ctx.profileStore.bufferProfile.street,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.profileStore.bufferProfile.street) = $event)),
          name: "street",
          label: _ctx.$localize('profile.edit.contact.street'),
          placeholder: _ctx.$localize('profile.edit.contact.add.street')
        }, null, 8, ["modelValue", "label", "placeholder"]),
        _createVNode(_component_app_input, {
          modelValue: _ctx.profileStore.bufferProfile.city,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.profileStore.bufferProfile.city) = $event)),
          name: "city",
          label: _ctx.$localize('profile.edit.contact.city'),
          placeholder: _ctx.$localize('profile.edit.contact.add.city')
        }, null, 8, ["modelValue", "label", "placeholder"]),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_app_select, {
            modelValue: _ctx.profileStore.bufferProfile.state,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.profileStore.bufferProfile.state) = $event)),
            name: "state",
            label: _ctx.$localize('profile.edit.contact.state'),
            placeholder: _ctx.$localize('profile.edit.contact.add.state'),
            options: _ctx.mainStore.states
          }, null, 8, ["modelValue", "label", "placeholder", "options"]),
          _hoisted_2,
          _createVNode(_component_app_input, {
            modelValue: _ctx.profileStore.bufferProfile.zipCode,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.profileStore.bufferProfile.zipCode) = $event)),
            name: "zipCode",
            inputmode: "numeric",
            label: _ctx.$localize('profile.edit.contact.zip'),
            placeholder: _ctx.$localize('profile.edit.contact.add.zip')
          }, null, 8, ["modelValue", "label", "placeholder"])
        ])
      ]),
      _: 1
    }, 8, ["validation-schema"])
  ], 64))
}